// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PortalMgrOutlinedSvg from "@fishx/icons-svg/es/asn/PortalMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var PortalMgrOutlined = function PortalMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PortalMgrOutlinedSvg
  }));
};

PortalMgrOutlined.displayName = 'PortalMgrOutlined';
export default React.forwardRef(PortalMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PortalMgrOutlined.js
// module id = 3823
// module chunks = 0